import { Link } from "react-router-dom";
import { colors, font, maxWidth } from "../styles/theme";
import { contacts, socials } from "../data/company";
import { services } from "../data/services";
import { useRequestModal } from "./ModalProvider";
import SocialGlyph from "./SocialIcons";
import useSectionNav from "../lib/useSectionNav";

// Тёмный футер: бренд, услуги, навигация, контакты.
export default function Footer() {
  const { openRequest } = useRequestModal();
  const { goToSection, goHome } = useSectionNav();

  return (
    <footer id="contacts" style={{ background: colors.ink, color: "#aab0b8" }}>
      <div style={{ maxWidth, margin: "0 auto", padding: "64px 22px 0" }}>
        <div
          className="footer-grid"
          style={{ paddingBottom: 48, borderBottom: "1px solid rgba(255,255,255,.1)" }}
        >
          {/* Бренд */}
          <div style={{ minWidth: 0 }}>
            <a href="/" onClick={goHome} style={{ display: "inline-flex", alignItems: "center", gap: 12, textDecoration: "none", cursor: "pointer" }}>
              <img src="/logo-klimat.png" alt="ВК-КЛИМАТ" style={{ width: 48, height: 48, objectFit: "contain" }} />
              <span style={{ fontFamily: font.display, fontWeight: 700, fontSize: 26 }}>
                <span style={{ color: "#fff" }}>ВК</span>
                <span style={{ color: colors.red }}>-КЛИМАТ</span>
              </span>
            </a>
            <p style={{ margin: "20px 0 0", fontSize: 14.5, lineHeight: 1.65, color: "#8b939d", maxWidth: 300 }}>
              Инженерная компания полного цикла: проектирование, монтаж и сервис систем вентиляции, кондиционирования и
              отопления.
            </p>
            {socials.length > 0 && (
              <div style={{ display: "flex", gap: 12, marginTop: 22, flexWrap: "wrap" }}>
                {socials.map((s) => (
                  <SocialIcon key={s.label} href={s.href} label={s.label} icon={s.icon} />
                ))}
              </div>
            )}
          </div>

          {/* Услуги */}
          <FooterCol title="Услуги">
            {services.map((s) => (
              <FooterLink key={s.num} to={`/uslugi?svc=${s.num}`}>
                {s.name}
              </FooterLink>
            ))}
          </FooterCol>

          {/* Компания */}
          <FooterCol title="Компания">
            <FooterLink href="/#uslugi" onClick={goToSection("uslugi")}>Услуги</FooterLink>
            <FooterLink href="/#about" onClick={goToSection("about")}>О компании</FooterLink>
            <FooterLink href="/#objects" onClick={goToSection("objects")}>Объекты</FooterLink>
            <FooterLink href="/#contacts" onClick={goToSection("contacts")}>Контакты</FooterLink>
            <button
              onClick={openRequest}
              style={{
                marginTop: 18,
                background: colors.red,
                color: "#fff",
                border: "none",
                fontFamily: font.display,
                fontWeight: 600,
                fontSize: 13,
                letterSpacing: ".04em",
                textTransform: "uppercase",
                padding: "13px 22px",
                borderRadius: 9,
                cursor: "pointer",
                transition: "background .18s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = colors.redDark)}
              onMouseLeave={(e) => (e.currentTarget.style.background = colors.red)}
            >
              Оставить заявку
            </button>
          </FooterCol>

          {/* Контакты — простым текстом */}
          <FooterCol title="Контакты">
            <a
              href={contacts.phoneHref}
              style={{ ...contactText, fontFamily: font.display, fontWeight: 700, fontSize: 18, color: "#fff" }}
            >
              {contacts.phone}
            </a>
            <a href={contacts.emailHref} style={contactText} onMouseEnter={textHover} onMouseLeave={textLeave}>
              {contacts.email}
            </a>
            <div style={contactText}>{contacts.address}</div>
            <div style={{ ...contactText, color: "#8b939d" }}>{contacts.hours}</div>
          </FooterCol>
        </div>
      </div>

      {/* Нижняя зона */}
      <div>
        <div
          style={{
            maxWidth,
            margin: "0 auto",
            padding: "22px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 14,
            flexWrap: "wrap",
            fontSize: 13,
            color: "#7a828c",
          }}
        >
          <div>© {new Date().getFullYear()} {contacts.requisites}</div>
          <Link
            to="/privacy-policy"
            style={{ color: "#7a828c", textDecoration: "none" }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#7a828c")}
          >
            Политика конфиденциальности
          </Link>
          <div>
            Создание сайта{" "}
            <a
              href="https://t.me/quack3r1"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#8b939d", textDecoration: "none", transition: "color .15s" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#8b939d")}
            >
              Яцюк Александр
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

const contactText = {
  display: "block",
  textDecoration: "none",
  color: "#cfd3d9",
  fontSize: 14.5,
  lineHeight: 1.5,
  padding: "6px 0",
};
const textHover = (e) => (e.currentTarget.style.color = "#fff");
const textLeave = (e) => (e.currentTarget.style.color = "#cfd3d9");

function FooterCol({ title, children }) {
  return (
    <div style={{ minWidth: 0 }}>
      <h4
        style={{
          fontFamily: font.display,
          fontWeight: 600,
          fontSize: 13,
          letterSpacing: ".1em",
          textTransform: "uppercase",
          color: "#fff",
          margin: "0 0 20px",
        }}
      >
        {title}
      </h4>
      {children}
    </div>
  );
}

// Кнопка-иконка мессенджера с SVG-глифом (Telegram / VK).
function SocialIcon({ href, label, icon }) {
  return (
    <a
      href={href}
      aria-label={label}
      title={label}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        width: 44,
        height: 44,
        borderRadius: 11,
        border: "1px solid rgba(255,255,255,.16)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textDecoration: "none",
        color: "#cfd3d9",
        transition: "border-color .15s, background .15s, color .15s",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = colors.red;
        e.currentTarget.style.background = "rgba(227,6,19,.12)";
        e.currentTarget.style.color = "#fff";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "rgba(255,255,255,.16)";
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.color = "#cfd3d9";
      }}
    >
      <SocialGlyph name={icon} size={20} />
    </a>
  );
}

function FooterLink({ to, href, onClick, children }) {
  const style = {
    display: "block",
    textDecoration: "none",
    color: "#aab0b8",
    fontSize: 14.5,
    lineHeight: 1.4,
    padding: "6px 0",
    transition: "color .15s",
    cursor: "pointer",
  };
  const hover = {
    onMouseEnter: (e) => (e.currentTarget.style.color = "#fff"),
    onMouseLeave: (e) => (e.currentTarget.style.color = "#aab0b8"),
  };
  // Якорная навигация (onClick) → <a>, иначе роут → <Link>
  if (onClick) {
    return (
      <a href={href || "#"} onClick={onClick} style={style} {...hover}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} style={style} {...hover}>
      {children}
    </Link>
  );
}
